import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installClientErrorLogging } from './services/clientLogService';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Could not find root element to mount to');
}

installClientErrorLogging();

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
